function removeUserFromApprovedArray({ state }) {
  let deleteUser = state.get('client.delete.user')
  if (deleteUser) {
    let users = state.get('users.approved')
    let filters = users.filter(user => {
      return user._id === deleteUser._id
    })
    if (filters && filters.length > 0) {
      state.splice('users.approved', users.indexOf(filters[0]), 1)
    }
  }
}

export default removeUserFromApprovedArray



// WEBPACK FOOTER //
// ./src/modules/user/actions/removeUserFromApprovedArray.js